import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import moment from 'moment';
import InputMask from 'react-input-mask';
import {DatePicker} from 'rsuite';
import { asignarPago } from '../../../../actions/payments';

import { useForm } from '../../../../hooks/useForm';
import { formValidation } from '../../../../helpers/formValidation';
export const Practicaja = () => {

    const dispatch = useDispatch()
    const {asignarPracticajaForm} = useSelector(state => state.forms);

    const [{account, invoice, atm, quantity}, handleInputChange, reset] = useForm({
        account: '',
        invoice: '',
        atm: '',
        quantity: ''
    });

    const [startDate, setStartDate] = useState('');

    const handleSubmit= (e)=>{
        formValidation(e, () => dispatch(
            asignarPago(
                'asignarPracticajaForm',
                account, 
                invoice, 
                atm, 
                quantity, 
                moment(startDate).format('DD/MM/yyyy'),
                'practicaja', 
                () =>reset()
            )
        ));
    }


    return (
        <div>
            <form 
                name="asignarPracticajaForm" 
                className="needs-validation needs-validation" 
                noValidate={true} 
                onSubmit={handleSubmit}
            >
                {
                    !!asignarPracticajaForm.msg &&
                        <div className={`alert alert-${asignarPracticajaForm.error?'danger':'success'}`} role="alert">
                            {asignarPracticajaForm.msg}
                        </div>
                }
                <div className="form-row align-items-center mb-0">
                    <div className="col-md-3">
                    <label className="">Cuenta</label>
                        <InputMask 
                            mask="999" 
                            maskChar={null}
                            type="text" 
                            className="form-control mb-2"
                            placeholder="(3 últimos dígitos)" 
                            autoComplete="off" 
                            name="account"
                            required={true}
                            value={account}
                            onChange={handleInputChange}
                        />
                    </div>
                    <div className="col-md-3">
                    <label className="">Folio</label>
                        <InputMask 
                            mask="9999" 
                            maskChar={null}
                            type="text" 
                            className="form-control mb-2"
                            placeholder="" 
                            autoComplete="off" 
                            name="invoice"
                            required={true}
                            value={invoice}
                            onChange={handleInputChange}
                        />
                    </div>
                    <div className="col-md-6">
                    <label className="">Número cajero</label>
                        <InputMask 
                            mask="MM*999" 
                            maskChar={null}
                            type="text" 
                            className="form-control mb-2"
                            placeholder="MM****" 
                            autoComplete="off" 
                            name="atm"
                            required={true}
                            value={atm}
                            onChange={handleInputChange}
                        />
                    </div>
                    <div className="col-md-6">
                    <label className="">Fecha de pago</label>


                        <DatePicker 
                            style={{ width: 280 }}
                            value={startDate}
                            onChange={date => setStartDate(date)} 
                            format="dd/MM/yyyy"
                            placeholderText="dd/mm/yyyy"
                            maxDate={new Date()}
                            className="form-control mb-2"
                            autoComplete="off" 
                            name="date"
                            required={true}
                        />
                        
                        {/* <DatePicker 
                            selected={startDate} 
                            onChange={date => setStartDate(date)} 
                            dateFormat="dd/MM/yyyy"
                            placeholderText="dd/mm/yyyy"
                            maxDate={new Date()}
                            className="form-control mb-2"
                            autoComplete="off" 
                            name="date"
                            required={true}
                        /> */}
                    </div>
                    <div className="col-md-6">
                        <label className="">Cantidad</label>
                        <div className="input-group">
                            <div className="input-group-prepend">
                                <span className="input-group-text" id="inputGroupPrepend">$</span>
                            </div>
                            <input 
                                type="text" 
                                className="form-control" 
                                aria-describedby="inputGroupPrepend" 
                                placeholder="Cantidad a abonar" 
                                name="quantity"
                                required={true} 
                                value={quantity}
                                onChange={handleInputChange}
                            />
                        </div>
                    </div>
                    <div className="col-md-12 text-right mt-2">
                        <button 
                            className="btn btn-primary waves-effect waves-light mb-2" 
                            type="submit"
                            disabled={!!asignarPracticajaForm.loading ? true : false}
                        >
                            {!!asignarPracticajaForm.loading && <i className="spinner-border spinner-border-sm" role="status"></i>} Guardar
                        </button>
                    </div>
                </div>
            </form>
        </div>
    )
}
